import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import Meta from 'vue-meta'
import Prismic from 'prismic-javascript'

Vue.use(Vuex)
Vue.use(Meta)
Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    query: null,
    posts: null,
    homepage: null
  },
  mutations: {
    updateApiData (state, query) {
      state.query = query
      state.posts = query.results.filter(function (item) {
        return item.type === 'article'
      })
      state.homepage = query.results.filter(function (item) {
        return item.type === 'homepage'
      })
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  data () {
    return {
      apiEndpoint: 'https://changing-lawyer.prismic.io/api/v2'
    }
  },
  methods: {
    getPosts () {
      let self = this
      Prismic.getApi(this.apiEndpoint, {}).then(function (api) {
        return api.query(
          [], // [Prismic.Predicates.at('document.type', 'article')],
          {
            orderings: '[my.article.order]',
            pageSize: 50
          }
        )
      }).then(function (response) {
        // console.log('Articles: ', response)
        self.$store.commit('updateApiData', response)
      }, function (err) {
        console.log('Something went wrong: ', err)
      })
    }
  },
  mounted () {
    this.getPosts()
  }
})



// WEBPACK FOOTER //
// ./src/main.js